import React from 'react'
import { Router } from '@reach/router'
import AccountList from './AccountList'
import AccountDomains from './AccountDomains'
import AccountCredits from './Credits'
import AccountSettings from './Settings'

function Account() {
  return (
    <Router>
      <AccountList path="/*" />
      <AccountDomains path="domains/:name/:id" />
      <AccountCredits path="credits/:name/:id" />
      <AccountSettings path="settings/:name/:id" />
    </Router>
  )
}

export default Account